import { APP_ONE_TRUST_ENABLED } from "../config";

interface CookieConsents {
    C0001: boolean;
    C0002: boolean;
    C0003: boolean;
    C0004: boolean;
    C0005: boolean;
    C0006: boolean;
}

/**
 * Reads the current state of all optanon-enabled script tags and checks if they are enabled.
 * Returns an object having the OneTrust categories as keys and their respective activation status (boolean) as value.
 */
export function getCurrentCookieConsents(): CookieConsents {
    if (APP_ONE_TRUST_ENABLED !== "true") {
        return {
            C0001: true,
            C0002: true,
            C0003: true,
            C0004: true,
            C0005: true,
            C0006: true,
        };
    }

    const defaultCookieConsents: CookieConsents = {
        C0001: true,
        C0002: false,
        C0003: false,
        C0004: false,
        C0005: false,
        C0006: false,
    };

    const documentScripts = Array.from(document.querySelectorAll("script"));

    // Matches all classnames that cookiePro uses for categorization
    const cookieProClassNameFormat = /optanon-category-(?:C\d{4}-?)+/;

    return documentScripts
        .filter((script) => {
            const className = script.getAttribute("class");
            return (
                className &&
                cookieProClassNameFormat.test(className) &&
                script.getAttribute("type") !== "text/plain"
            );
        })
        .reduce((consents, node) => {
            const classNames = node.getAttribute("class")?.split("-") ?? [];
            classNames.slice(2).forEach((c) => {
                if (c in consents) {
                    consents[c as keyof CookieConsents] = true;
                }
            });
            return consents;
        }, defaultCookieConsents);
}
